import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';
import * as monthUtils from '@actual-app/core/shared/months';

import { aspectoDeRecuerdo } from '#components/mobile/budget/recuerdosAspecto';
import { Icono } from '#components/mobile/ui/Icono';
import { Tarjeta } from '#components/mobile/ui/Tarjeta';
import { color, espacio } from '#components/mobile/ui/tokens';
import { useNavigate } from '#hooks/useNavigate';

import { Botella } from './Botella';
import { useLlegadas } from './ProveedorLlegadas';

/**
 * Aviso discreto en Inicio cuando una botella ha llegado (por sync o al
 * abrir la app): no hay evento de servidor y la vibración necesita un
 * gesto, así que la llegada empieza al tocarlo, sobre la ficha.
 */
export function AvisoLlegada() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pendientes, abrir } = useLlegadas();
  const r = pendientes[0];
  if (!r) {
    return null;
  }
  const otras = pendientes.length - 1;
  const nombre = [r.base.emoji, r.base.nombre].filter(Boolean).join(' ');
  return (
    <View
      style={{
        padding: `${espacio.fila}px ${espacio.margen}px 0`,
        flexShrink: 0,
      }}
    >
      <Tarjeta
        data-testid="aviso-llegada"
        onPress={() => {
          void navigate(`/categories/${r.base.categoriaId}/ficha`);
          abrir(r.base.rid);
        }}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: espacio.icono,
          padding: '10px 14px',
        }}
      >
        <View style={{ width: 28, alignItems: 'center' }}>
          <Botella
            aspecto={aspectoDeRecuerdo(r, monthUtils.currentDay())}
            ancho={26}
          />
        </View>
        <View style={{ flex: 1, minWidth: 0 }}>
          <Text style={{ fontSize: 15, fontWeight: 800, color: color.fg }}>
            <Trans>A bottle has arrived</Trans>
          </Text>
          <Text
            style={{
              fontSize: 13,
              color: color.fg2,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {otras > 0
              ? t('{{name}} and {{count}} more', { name: nombre, count: otras })
              : nombre}
          </Text>
        </View>
        <Icono nombre="cr" size={18} style={{ color: color.fg3 }} />
      </Tarjeta>
    </View>
  );
}
